import HomeHero from './components/HomeHero';
import FocusPanel from './components/FocusPanel';
import LatestWorks from './components/LatestWorks';
import TopicsSection from './components/TopicsSection';
import SiteIntro from './components/SiteIntro';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Home() {
  usePageMeta(
    '玉女心经2 - 影视作品简介与剧情解析',
    '玉女心经2为您汇集详细的影视剧情介绍、角色信息和作品背景，带来全面的内容浏览体验，满足影视爱好者的多样需求。'
  );

  return (
    <>
      <HomeHero />
      <FocusPanel />
      <LatestWorks />
      <TopicsSection />
      <SiteIntro />
    </>
  );
}